import { RiskLevel } from "@/model/RiskLevel";
import TowerHamletsLogo from "@/assets/regions/RESET_Logo_Tower_hamlets.jpg";
import { DefaultLower } from "@/model/DefaultBanners";
const DefaultBanner = {
    rawCopy: "For alcohol advice and support, call Reset on 0203 889 9510 or email <u>towerhamlets.info@cgl.org.uk</u>",
    logoLink: "https://www.changegrowlive.org/reset-recovery-support-service-tower-hamlets"
};
const Increasing = {
    rawCopy: "For Increasing Risk scores we recommend you cut down your drinking. " +
        "Speak to your GP or <u>contact RESET</u> for advice and support.",
    logoLink: "https://www.changegrowlive.org/reset-recovery-support-service-tower-hamlets"
};
export default {
    name: "Tower Hamlets",
    logo: {
        file: TowerHamletsLogo,
        width: 204,
        height: 245
    },
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: DefaultBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: Increasing,
        [RiskLevel.Higher]: DefaultBanner,
        [RiskLevel.High]: DefaultBanner
    },
    clinics: [
        {
            name: "Reset Treatment Service",
            isPrimaryProvider: true,
            alwaysShowInResults: true,
            tagline: "For anyone over 18 in Tower Hamlets with an alcohol issue",
            description: 'Contact ${name} on ${phone} or email <a href="mailto:${email}">${email}</a>',
            phone: ["0203 889 9510"],
            email: "towerhamlets.info@cgl.org.uk",
            website: "https://www.changegrowlive.org/reset-treatment-recovery-support-service/info"
        },
        {
            name: "Safe East",
            isPrimaryProvider: true,
            alwaysShowInResults: true,
            tagline: "For anyone under 18 in Tower Hamlets with an alcohol issue",
            phone: ["020 3954 0091"],
            email: "compass.towerhamletsyphws@nhs.net",
            website: "https://www.compass-uk.org/services/tower-hamlets-compass-safe-east/"
        }
    ]
};
//# sourceMappingURL=TowerHamlets.js.map